<template>
  <div class="contest-detail">
    <div class="detail-poster">
      <img :src="detail.banner" />
    </div>
    <div class="menu">
      <div class="menu-box">
        <div
          class="menu-item"
          :class="menu_type == 'match_introduction' ? 'active' : ''"
          @click="onMenuClick('match_introduction')"
        >
          大赛简介
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'design_introduction' ? 'active' : ''"
          @click="onMenuClick('design_introduction')"
        >
          设计说明
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'about_organizer' ? 'active' : ''"
          @click="onMenuClick('about_organizer')"
        >
          关于主办方
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'match_instructions' ? 'active' : ''"
          @click="onMenuClick('match_instructions')"
        >
          参赛须知
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'match_information' ? 'active' : ''"
          @click="onMenuClick('match_information')"
        >
          参赛资料
        </div>
        <div
          class="menu-item"
          :class="menu_type == 'entries' ? 'active' : ''"
          @click="onMenuClick('entries')"
        >
          参赛作品
        </div>
      </div>
      <div class="btn-box">
        <div class="sign-in-btn" @click="onSignIn">
          <img src="../../assets/images/icon-sign-in-match.png" />
          {{ detail.is_signin ? '已报名' : '在线报名' }}
        </div>
        <div v-if="canUpload" class="upload-btn" @click="onUploadClick">

          <img src="../../assets/images/icon-upload-match.png" />
          {{ detail.is_upload.match_uuid ? '查看作品' :'上传作品' }}
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="menu_type != 'entries' && !show_upload" class="content-title">
        —— {{ menu_type | menu_type }} ——
      </div>
      <div v-else-if="menu_type == 'entries'" class="content-title-list">
        全部作品<span>({{posts_list.length}})</span>
      </div>
      <div
        style="margin-top: 75px"
        v-if="menu_type != 'entries' && !show_upload"
        v-html="detail[menu_type]"
      ></div>
      <div
        class="upload-form"
        v-else-if="menu_type == 'match_introduction' && show_upload"
      >
        <div class="form-container">
          <div class="title">上传作品</div>
          <div class="tips">
            参赛作品不支持删除,大赛进行中上传后的作品如需修改,可在【我的笔记】点击"编辑"进行修改
          </div>
          <div class="form">
            <Form ref="up_form" label-position="top" :model="form">
              <FormItem label="作品名称：" prop="title" required style="max-width: 750px">
                <Input v-model="form.title" placeholder="请输入作品名称" :disabled="form.status == 2" />
              </FormItem>
              <FormItem prop="image_list"
                label="作品图片(可多张)："
                required
              >
                <div class="upload-list">
                  <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    multiple
                    :before-upload="(file) => beforeUpload(file,'img_list')"
                    :on-success="
                      (response, file, fileList) =>
                        handleSuccess(response, file, fileList, 'img_list')
                    "
                    :show-upload-list="false"
                    :format="['jpg', 'jpeg', 'png', 'gif','webp']"
                    accept=".jpg,.jpeg,.png,.gif,.webp" :disabled="form.status == 2"
                  >
                    <template>
                      <div class="upload-btn">
                        <img
                          src="../../assets/images/icon-add-match-upload.png"
                        />
                        <div class="btn-text">上传参赛作品</div>
                        <div class="btn-desc">
                          <p>支持jpg/gif/png格式RGB模式</p>
                          <p>不超过20M</p>
                        </div>
                      </div>
                    </template>
                  </Upload>
                  <img v-for="(item,index) in form.image_list" :key="index" :src="item|default_img" />
                </div>
              </FormItem>
              <FormItem prop="content" label="作品说明" required style="max-width:750px;">
                <textarea v-model="form.content" :rows="4" placeholder="请输入作品说明" :disabled="form.status == 2"></textarea>
              </FormItem>
              <FormItem  v-for="(item,index) in form.custom_field" :key="index" :label="item.name"  :prop="'custom_field.' + index + '.value'"
                :rules="{required:item.is_required, message:  item.name+'不能为空', trigger: 'blur'}">
                    <Input v-model="item.value" :placeholder="'请输入'+item.name" v-if="item.type=='text'"  style="max-width: 750px" />
                    <Date-picker  @on-change="handleChange($event,index)" format="yyyy-MM-dd" type="date" :placeholder="'请选择'+item.name" v-model="item.value" v-if="item.type=='date'"></Date-picker>
                    <Date-picker @on-change="handleChange($event,index)" format="yyyy-MM-dd HH:mm:ss" type="datetime" :placeholder="'请选择'+item.name" v-model="item.value" v-if="item.type=='time'"></Date-picker>

                    <Select v-model="item.value" :placeholder="'请选择'+item.name" v-if="item.type=='select'" style="max-width: 750px">
                        <Option :value="i.name" v-for="(i,y) in item.options" :key="y">{{ i.name }}</Option>
                    </Select>
                    <Checkbox-group v-model="item.value" v-if="item.type=='checkbox'">
                        <Checkbox :label="i.name"  v-for="(i,y) in item.options"  :key="y">{{ i.name }}</Checkbox>
                    </Checkbox-group>
                    <Upload
                        action=""
                        :show-upload-list="true"
                        :before-upload="(file) => beforeUpload(file, index)"
                        accept=".jpg,.jpeg,.png,.gif,.webp"
                        :format="['jpg', 'jpeg', 'png', 'gif','webp']"
                        v-if="item.type=='img'"
                    >

                        <div class="sign-img-box" style="width: 80px;height:80px;border:1px dashed #ddd;">
                            <img class="img" v-if="item.value" :src="item.value" style="width: 80px;height:80px;" />
                            <img v-else src="../../assets/images/icon-add-match-upload.png" class="icon" />
                        </div>
                    </Upload>
                      <Upload action="" :before-upload="(file) => beforeUpload(file, index)" v-if="item.type=='file'">
                        <Button>上传文件</Button>
                        <a style="margin-left:10px;" v-if="item.value">{{ item.fileName }}</a>
                    </Upload>
                </FormItem>
                <FormItem>
                    <Checkbox v-model="form.is_agree">
                        <span>我已同意</span>
                        <span style="color:#fa3d5a"  @click.stop="toCommitment(item.id)" v-for="(item,index) in uploadCommitments" :key="index">《{{ item.title }}》</span>
                        <span> 等所有条款</span>
                    </Checkbox>
                </FormItem>
            </Form>
            <Button :disabled="form.status == 2" @click="onPostsSubmit" class="submit">确认上传</Button>
          </div>
        </div>
      </div>
      <!-- 瀑布流 -->
      <div
        v-else
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
        <masonry
          :cols="{ default: 4, 1000: 4, 700: 3, 400: 2 }"
          :gutter="{ default: '20px', 1000: '20px', 700: '15px', 400: '10px' }"
        >
          <div
            v-for="(item, index) in posts_list"
            :key="index"
            @click="onWorksItemClick(item)"
          >
            <template>
              <div class="masonry-item">
                <img
                  :src="item.cover | default_img"
                  @load="onImageLoad"
                  class="masonry-image"
                />
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="center-box">
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-views-contest.png"
                        alt=""
                      />{{ item.view_times }}
                    </div>
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-comment-contest.png"
                        alt=""
                      />{{item.comment_count}}
                    </div>
                    <div class="center-items">
                      <img
                        src="../../assets/images/icon-like-contest.png"
                        alt=""
                      />{{item.zan_count}}
                    </div>
                  </div>
                  <div class="bottom-box">
                    <div class="nick-avatar">
                      <img
                        class="avatar"
                        :src="item.member.avatar | default_img"
                      />
                      <div class="nick">
                        {{ item.member.nickname || item.member.username }}
                      </div>
                    </div>
                    <!-- <div class="like-box">
                                            <img src="../../assets/images/icon-like.png" style="width:16px;height:16px;" />
                                            <div style="margin-left:3px;">{{item.collect_count}}</div>
                                        </div> -->
                  </div>
                  <!-- <p>{{ item.description }}</p> -->
                </div>
              </div>
            </template>
          </div>
        </masonry>
      </div>
    </div>
    <SignIn v-if="show_sign_in" @on-close="onCloseSignIn" :uuid="uuid" :commitments="signCommitments" :custom_field="signCustomField"></SignIn>
    <ArticleDetail ref="articleDetail" v-if="show_detail" @on-close="onCloseArticleDetail" :uuid="post_uuid" :postType="2"></ArticleDetail>
  </div>
</template>
<script>
import { GetMatchDetail,MatchPostsUpload,MatchSignInCheck,MatchPostsList } from "@/api/social";
import SignIn from "./components/SignIn";
import ArticleDetail from '@/components/ArticleDetail';
import { uploadFileToOSS } from '@/utils/oss'
export default {
  components: {
    SignIn,ArticleDetail
  },
  data() {
    return {
      menu_type: "match_introduction",
      posts_list: [],
      detail: {},
      show_sign_in: false,
      show_upload: false,
      form: {
        title: "",
        image_list: [],
        content: "",
        is_agree:false,
        custom_field:[]
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      uuid:'',
      show_detail:false,
      post_uuid:'',
      is_signin:''
    };
  },
  computed:{
    is_login(){
      return this.$store.state.is_login;
    },
    canUpload(){
      const { status, match_time,is_signin,is_upload } = this.detail;

      //>状态不在可上传状态
      // if(status != 2){
      //   return false;
      // }

      if(!is_signin){
        return false;
      }

      // 将 match_time 转换为 Date 对象并比较当前时间
      const matchTimeDate = new Date(match_time);
      const now = new Date();

      // 判断是否超过了 match_time
      if (now > matchTimeDate && !is_upload.match_uuid) {
        return false;
      }

      return true;
    },
    canSignIn(){

      const { status, sign_time } = this.detail;

      // if(status != 1){
      //   return false;
      // }

      // 将 match_time 转换为 Date 对象并比较当前时间
      const matchTimeDate = new Date(sign_time);
      const now = new Date();

      // 判断是否超过了 match_time
      if (now > matchTimeDate) {
        return false;
      }

      return true;
    },
    signCommitments() {
      if(!this.detail.commitments) {
        return []
      }
      return this.detail.commitments.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    signCustomField() {
      if(!this.detail.custom_field) {
        return []
      }
       return this.detail.custom_field.filter((i)=>{
        return i.use_type== 'sign'
      })
    },
    uploadCommitments() {
      if(!this.detail.commitments) {
        return []
      }
       return this.detail.commitments.filter((i)=>{
        return i.use_type== 'upload'
      })
    },
    
    
  },
  filters: {
    menu_type(type) {
      switch (type) {
        case "match_introduction":
          return "大赛简介";
        case "design_introduction":
          return "设计说明";
        case "about_organizer":
          return "关于主办方";
        case "match_instructions":
          return "参赛须知";
        case "match_information":
          return "参赛资料";
        case "entries":
          return "参赛作品";
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    const { uuid } = this.$route.params;
    const {post_uuid} = this.$route.query;
    if (!uuid) {
      console.log("uuid is null");
      history.back();
      return;
    }
    console.log('post_uuid',post_uuid)
    if(post_uuid){
      this.post_uuid = post_uuid;
      this.show_detail = true;
    }
    this.uuid = uuid;
    this.onGetDetail();
    this.onGetPostsList();
    // if(this.is_login){
    //   this.onSiginCheck();
    // }
  },
  methods: {
    handleChange(e,index) {
            this.form.custom_field[index].value = e
    },
    beforeUpload(file, index) {
        this.uploadSectionFile(file, index)
        return false
    },
    async uploadSectionFile(file, index) {
        const url = await uploadFileToOSS(file, 'template')
        if(index === 'img_list'){
          this.form.image_list.push(url);
        }else{
          this.form.custom_field[index].value = url
          this.form.custom_field[index].fileName = file.name
        }
    },
    async onSiginCheck(){
      const {data} = await MatchSignInCheck({uuid:this.uuid});
      if(data.is_signin){
          this.is_signin = true;
          return;
      }
    },
    onSignIn() {
      if(!this.is_login) {
        this.$layer.msg("请先登录");
        this.$router.push({name:"Login"});
        return;
      }

      if(!this.canSignIn){
        this.$layer.msg("已过报名时间或比赛已结束");
        return;
      }

      if(this.detail.is_signin){
        this.$layer.msg('您已报名');
        return;
      }

      this.show_sign_in = true;
    },
			onCloseArticleDetail(e){
				console.log('关闭弹窗');
				this.show_detail = false;
			},
    async onGetPostsList(){
        try{
            const {data} = await MatchPostsList({uuid:this.uuid});
            this.posts_list = data;
        }catch(e){
            console.log('e-list',e);
            this.$layer.msg(e.msg);
        }
    },
    onMenuClick(menu){
        this.menu_type = menu;
        this.show_upload = false;
    },
    async onPostsSubmit(){
        try{
          // console.log('this.form',this.form);
            if(this.form.uuid && this.form.status == 2){
              this.$layer.msg("当前作品已经审核完成,无法再次更改")
              return;
            }
          // return;
            const {is_agree,title,image_list,content} = this.form;
            if(!is_agree){
                this.$layer.msg('请先同意规则');
                return;
            }
            if(!title || !image_list.length || !content){
                this.$layer.msg("请填写完整信息");
                return;
            }
            let msg = ''
            this.form.custom_field.forEach((i)=>{
                if(i.is_required && !i.value) {
                    msg = i.name + '必填'
                }
            })
            if(msg) {
                this.$layer.msg(msg);
                return;
            }
            const param = this.form;
            param.match_uuid = this.uuid;
            console.log('param===',param);
            const {data} = await MatchPostsUpload(param);
            console.log('data',data.post_uuid);
            this.$layer.msg('上传成功,即将跳转作品发布页面,请完善信息并选择是否发布');
            this.$refs['up_form'].resetFields();
            this.form.image_list = [];
            this.$router.push({name:'Posts',params:{uuid:data.post_uuid}});
        }catch(e){
            console.log('e-upload-e',e);
            this.$layer.msg(e.msg);
        }
    },
    handleSuccess(response, file, fileList, field) {
      const length = this.form.image_list.length;
      if (length > 18) {
        this.$layer.msg("最多上传18张图片");
        return;
      }
      if (field === "img_list") {
        this.form.image_list.push(response.data.url);
      }
    },
    async onUploadClick() {
        try{
          if(!this.canUpload){
            this.$layer.msg("已过报名时间或比赛已结束");
            return;
          }
            const {data} = await MatchSignInCheck({uuid:this.uuid});
            console.log('data',data);
            if(!data.is_signin){
                this.$layer.msg('请先报名比赛');
                return;
            }
            const {is_upload} = this.detail;
        //     title: "",
        // image_list: [],
        // content: "",
        // is_agree:false,
        // custom_field:[]
            // const {uuid,status,content,cover,image_list,custom_field,title} = is_upload;
            this.$set(this,'form',is_upload);
            this.show_upload = true;
            this.menu_type = 'match_introduction';
        }catch(e){
            console.log('e-sign-in-e',e);
            this.$layer.msg(e.msg);
        }
    },
    onCloseSignIn(data) {
      if(data){
        this.onGetDetail();
      }
      this.show_sign_in = false;
    },
    async onGetDetail() {
      try {
        const { data } = await GetMatchDetail({ uuid: this.uuid });
        console.log("data----", data);
        this.detail = data;
        // console.log('is_upload',data.is_upload,data.is_upload.match_uuid);
        this.form.custom_field = this.detail.custom_field.filter((i)=>{
          return i.use_type== 'upload'
        })
      } catch (e) {
        console.log("eee-", e);
      }
    },
    onWorksItemClick(item) {
      console.log("item", item);
      this.post_uuid = item.uuid;
      this.show_detail = true;
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    toCommitment(id) {
        const uri = `${window.location.origin}/commitment?id=${id}`;
        window.open(uri, "_blank");
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./contestdetail.scss";
</style>
